import Log from "@workspace/nextjs_utils/src/Log";
import { reportPendingLogin } from "./pendingLogin";
import runSafely from "./runSafely";

const MAX_QUEUED_CALLS = 50;

export const LOAD_TIMEOUT_MS = 30_000;

let status: OptimoveStatus = "idle";
let pending: OptimoveCall[] = [];

const optimoveQueue = {
  getStatus: () => status,

  push: (call: OptimoveCall) => {
    if (status === "failed") {
      return;
    }
    if (pending.length >= MAX_QUEUED_CALLS) {
      pending.shift();
    }
    pending.push(call);
  },

  ready: (api: OptimoveApi, userId?: string) => {
    status = "identifying";
    const flush = () => {
      status = "ready";
      const queued = pending;
      pending = [];
      if (userId) {
        runSafely(reportPendingLogin, api);
      }
      for (const call of queued) {
        runSafely(call, api);
      }
    };
    const identity = userId
      ? runSafely((current) => current.setUserId(userId), api)
      : runSafely((current) => current.signOutUser(), api);
    Promise.resolve(identity).then(flush, flush);
  },

  fail: (reason: string) => {
    if (status === "failed") {
      return;
    }
    status = "failed";
    pending = [];
    Log.warn("Optimove SDK unavailable, calls are no-ops", { reason });
  },

  giveUpIfStillLoading: () => {
    if (status !== "idle") {
      return;
    }
    optimoveQueue.fail(`script did not load within ${LOAD_TIMEOUT_MS}ms`);
  },

  reset: () => {
    status = "idle";
    pending = [];
  },
};

export default optimoveQueue;
